import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { GlobalStylesComponent } from './globalStyles';
import { theme } from './theme';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStylesComponent />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
